export default {
  'messages.listEmptyText': 'Görüntülenecek kayıt bulunamamıştır',
  'messages.noOption': 'Seçenek Yok',
};
